// extracted by mini-css-extract-plugin
module.exports = {"input":"TextArea_input__2wqx-","row":"TextArea_row__espXh","iconDisplay":"TextArea_iconDisplay__2-o0y"};